import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import { generalSettingSelector, handleSaveSettings } from '@/redux/slice/setting.slice';
import { BlockStack, Box, Card, TextField } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export const ManualBlock = () => {
  const { t } = useTranslation('general_settings');
  const generalSettings = useSelector(generalSettingSelector);
  const dispatch = useDispatch();

  return (
    <Card padding={'300'}>
      <BlockStack gap={'300'}>
        <Box>
          <BoldText>{t('sections.checkoutValidation.manualBlock.title')}</BoldText>
          <RegularText tone="subdued">{t('sections.checkoutValidation.manualBlock.helpText')}</RegularText>
        </Box>
        <TextField
          label={t('sections.checkoutValidation.manualBlock.checkoutSelectorLabel')}
          placeholder={t('sections.checkoutValidation.manualBlock.checkoutSelectorPlaceholder')}
          helpText={t('sections.checkoutValidation.manualBlock.checkoutSelectorHelpText')}
          value={generalSettings.manualSelectorBlockCheckoutButton}
          onChange={(value) => dispatch(handleSaveSettings({ manualSelectorBlockCheckoutButton: value }))}
          autoComplete="off"
        />
        <TextField
          label={t('sections.checkoutValidation.manualBlock.addToCartSelectorLabel')}
          placeholder={t('sections.checkoutValidation.manualBlock.addToCartSelectorPlaceholder')}
          helpText={t('sections.checkoutValidation.manualBlock.addToCartSelectorHelpText')}
          value={generalSettings.manualSelectorBlockAddToCartButton}
          onChange={(value) => dispatch(handleSaveSettings({ manualSelectorBlockAddToCartButton: value }))}
          autoComplete="off"
        />
      </BlockStack>
    </Card>
  );
};
